import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSpreadsheet = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.10026 9.87747H11.9003M4.10026 7.42252H11.9003M14.0669 13.6333C14.0669 13.8632 13.9756 14.0836 13.8131 14.2462C13.6505 14.4087 13.4301 14.5 13.2003 14.5H2.80026C2.57041 14.5 2.34997 14.4087 2.18743 14.2462C2.0249 14.0836 1.93359 13.8632 1.93359 13.6333V2.36668C1.93359 2.13682 2.0249 1.91638 2.18743 1.75385C2.34997 1.59132 2.57041 1.50001 2.80026 1.50001H11.4669C11.5794 1.49948 11.6909 1.52115 11.795 1.56379C11.8991 1.60642 11.9938 1.66917 12.0736 1.74845L13.8069 3.41245C13.8894 3.49286 13.9549 3.58901 13.9996 3.6952C14.0443 3.8014 14.0671 3.91547 14.0669 4.03067V13.6333ZM4.38915 5.1108H11.6114C11.6114 5.1108 11.9003 5.1108 11.9003 5.39969V12.0441C11.9003 12.0441 11.9003 12.333 11.6114 12.333H4.38915C4.38915 12.333 4.10026 12.333 4.10026 12.0441V5.39969C4.10026 5.39969 4.10026 5.1108 4.38915 5.1108Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSpreadsheet;
